import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

const columns = [
  { id: "date", label: "Date", minWidth: 90 },
  { id: "type", label: "Type", minWidth: 80 },
  { id: "billNo", label: "Bill No", minWidth: 110 },
  {
    id: "totalAmount",
    label: "Total Amount",
    minWidth: 110,
    align: "right",
    format: value => `₹${value.toLocaleString("en-IN")}`,
  },
  {
    id: "pendingAmount",
    label: "Pending Amount",
    minWidth: 110,
    align: "right",
    format: value => `₹${value.toLocaleString("en-IN")}`,
  },
  { id: "due", label: "Due", minWidth: 70, align: "center" },
  { id: "dueDate", label: "Due Date", minWidth: 90 },
  {
    id: "daysOverdue",
    label: "Days/Adj. by",
    minWidth: 110,
    render: row => {
      if (row.type === "Payment") {
        return row.adjustedBy;
      }
      return row.daysOverdue;
    },
  },
  { id: "clearDays", label: "Clear Days", minWidth: 90, align: "center" },
  {
    id: "adjustedAmount",
    label: "Adjusted Amount",
    minWidth: 110,
    align: "right",
    format: value => (value ? `₹${value.toLocaleString("en-IN")}` : "-"),
  },
];

const CustomerTransactionsTable = ({ transactions }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper
      sx={{
        width: "100%",
        boxShadow: "none",
        border: "1px solid #E5E7EB",
        borderRadius: "0.5rem",
      }}>
      <TableContainer
        sx={{ maxHeight: { xs: "400px", md: "500px" } }}
        className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  key={column.id}
                  align={column.align || "left"}
                  sx={{
                    minWidth: column.minWidth,
                    width: column.minWidth,
                    backgroundColor: "#F9FAFB",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#374151",
                    borderBottom: "2px solid #E5E7EB",
                    padding: "12px 16px",
                  }}
                  className="font-outfit">
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.id}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#F9FAFB",
                      },
                    }}>
                    {columns.map(column => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align || "left"}
                          sx={{
                            padding: "12px 16px",
                            fontSize: "14px",
                            color:
                              row.type === "Payment"
                                ? "#22C55E"
                                : column.id === "pendingAmount" && value > 0
                                ? "#FC4747"
                                : "#4B5563",
                          }}
                          className="font-outfit">
                          {column.render
                            ? column.render(row)
                            : column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={transactions.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          borderTop: "1px solid #E5E7EB",
          ".MuiTablePagination-select": {
            borderRadius: "0.375rem",
          },
        }}
      />
    </Paper>
  );
};

export default CustomerTransactionsTable;
